<template>
    <div>
        <attendance-overview-detail
            v-if="bureauId"
            :bureau-id="bureauId">
        </attendance-overview-detail>

        <attendance-bureau v-else></attendance-bureau>
    </div>
</template>

<script>
import AttendanceBureau from '@/views/Liff/Modules/History/pages/AttendanceBureau'
import AttendanceOverviewDetail from '@/views/Liff/Modules/History/pages/AttendanceOverviewDetail'

export default {
    name: 'HistoryAttendanceBureau',

    data () {
        return {
            bureauId: null
        }
    },

    components: {
        AttendanceBureau,
        AttendanceOverviewDetail
    },

    created () {
        this.bureauId = this.$route.query.id
    }
}
</script>

<style lang="scss" scoped>

</style>
